import React from 'react';
import templates from './templates';
import './DocumentWidget.css';

export const DocumentWidget = ({
  documentUrl = '',
  documentType = '',
  pageNumber = 1,
  autoScroll = false,
  scrollInterval = 10,
  fileName = '',
  template = 'Clean',
}) => {
  const Template = templates[template];

  if (!Template) {
    console.error('Template not found:', template);
    return <div>Template not found: {template}</div>;
  }

  return (
    <Template
      documentUrl={documentUrl}
      documentType={documentType}
      pageNumber={pageNumber}
      autoScroll={autoScroll}
      scrollInterval={scrollInterval}
      fileName={fileName}
    />
  );
};
